//DBTables
import { ModuleTypeId } from "../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import ConfigVarmeSekundarVatten from "./ConfigVarmeSekundarVatten";
import ConfigNoConfiguration from "./ConfigNoConfiguration";
import { DTOBuilding, DTOModule } from "../../types/building";
import ConfigByggnadsData from "./ConfigByggnadsData";
import ConfigKylmaskin from "./ConfigKylmaskin";
import ConfigKylaVattenburet from "./ConfigKylaVattenburet";
import ConfigrationVentilationFXochF from "./ConfigVentilationFXochF";
import ConfigVentilationFTXochFT from "./ConfigVentilationFTXochFT";
// import ConfigVentilationF from "./ConfigVentilationF";
import ConfigVentilationS from "./ConfigVentilationS";
import ConfigVarmePrimarFjarr from "./ConfigVarmePrimarFjarr";
import ConfigVarmePrimarPump from "./ConfigVarmePrimarPump";

import ConfigDirektverkandeEL from "./ConfigDirektverkandeEL";

interface IProps {
  module: DTOModule;
  formHook: UseFormReturn;
  configurationData: any;
  building: DTOBuilding;
}

const ModuleEditor = ({ module, formHook, configurationData, building }: IProps) => {
  const getModuleTypeConfigurator = (module: DTOModule) => {
    switch (module.moduleTypeId) {
      // case "VentTest1":
      //   return <HeatTest1ConfigurationDx module={module} callbacksRef={callbacks} data={configurationData} />;
      // case "VentTest2":
      //   return <HeatTest1Configuration module={module} callbacksRef={callbacks} data={configurationData} />;
      case ModuleTypeId.Byggnadsdata:
        return <ConfigByggnadsData building={building} module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.Lokaler:
        return <ConfigNoConfiguration module={module} formHook={formHook} data={configurationData} />;
      // Ventilation
      //      Ventilation FT (X)
      case ModuleTypeId.VentilationFTX:
        return <ConfigVentilationFTXochFT module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VentilationFT:
        return <ConfigVentilationFTXochFT module={module} formHook={formHook} data={configurationData} />;
      //      Ventilation F (X)
      case ModuleTypeId.VentilationFX:
        return <ConfigrationVentilationFXochF module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VentilationF:
        return <ConfigrationVentilationFXochF module={module} formHook={formHook} data={configurationData} />;
      //      Ventilation S
      case ModuleTypeId.VentilationS:
        return <ConfigVentilationS module={module} formHook={formHook} data={configurationData} />;
      //Värme
      case ModuleTypeId.VarmePrimarFjarr:
        return <ConfigVarmePrimarFjarr module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmePrimarPump:
        return <ConfigVarmePrimarPump module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeSekundarVatten:
        return <ConfigVarmeSekundarVatten module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElVarmepump:
        return <ConfigDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElStralningsvarmare:
        return <ConfigDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElGolvvarme:
        return <ConfigDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElAirotemper:
        return <ConfigDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElRadiatorer:
        return <ConfigDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      //Kyla
      case ModuleTypeId.KylaVattenburet:
        return <ConfigKylaVattenburet module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.KylaMaskin:
        return <ConfigKylmaskin module={module} formHook={formHook} data={configurationData} />;

      default:
        return <ConfigNoConfiguration module={module} formHook={formHook} data={configurationData} />;
    }
  };

  return <>{getModuleTypeConfigurator(module)}</>;
};

export default ModuleEditor;
